import { useState } from 'react';
import { connect } from 'react-redux';
import './chartStyle.css';
import { SketchPicker } from 'react-color';
import SliderWithInput from '../SliderWithInput';
import { FormControl, MenuItem, Popover, Select } from '@mui/material';
import SwitchWithInput from '../SwitchWithInput';
import { Dispatch } from 'redux';
import { updateCalendarStyleOptions } from '../../../redux/ChartPoperties/ChartControlsActions';
import { ChartOptionsProps, ChartOptionsStateProps } from '../CommonInterfaceForChartOptions';

const CalendarChartStyles = ({
  // state
  chartControls,
  tabTileProps,

  // dispatch
  updateCalendarStyleOptions,
  iconColor,
}: ChartOptionsProps & {
  updateCalendarStyleOptions: (propKey: string, option: string, value: any) => void;
  iconColor?: string;
}) => {
  var propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  var calStyle = chartControls.properties[propKey].calendarStyleOptions;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <div className="optionsInfo">
      <div
        className="optionDescription"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '5px',
          paddingLeft: '0.2rem',
        }}
      >
        <label
          htmlFor="enableDisable"
          className="enableDisableLabel"
          style={{ color: iconColor ? iconColor : '#404040' }}
        >
          Split Line
        </label>

        <div
          style={{
            width: '50px',
            height: '24px',
            display: 'flex',
            transform: 'translateX(63px)',
            marginBottom: '9px',
          }}
        >
          <SwitchWithInput
            isChecked={calStyle.showSplitLine}
            onSwitch={() => {
              updateCalendarStyleOptions(propKey, 'showSplitLine', !calStyle.showSplitLine);
            }}
          />
        </div>
      </div>
      {calStyle.showSplitLine ? (
        <>
          <div
            className="optionDescription"
            style={{ marginTop: '0', paddingTop: '2px', color: iconColor ? iconColor : '#404040' }}
          >
            Color
          </div>
          <div
            style={{
              height: '1.25rem',
              width: '25%',
              backgroundColor: calStyle.splitLineColor,
              color: calStyle.splitLineColor,
              border: '2px solid darkgray',
              marginLeft: '12px',
              marginRight: 'auto',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
          >
            {'  '}
          </div>

          <div
            className="optionDescription"
            style={{ marginTop: '5px', color: iconColor ? iconColor : '#404040' }}
          >
            Width
          </div>
          <SliderWithInput
            percent={true}
            sliderValue={calStyle.splitLineWidth}
            sliderMinMax={{ min: 0, max: 60, step: 1 }}
            changeValue={(value: any) =>
              updateCalendarStyleOptions(propKey, 'splitLineWidth', value)
            }
          />

          <div
            className="optionDescription"
            style={{ marginTop: '5px', color: iconColor ? iconColor : '#404040' }}
          >
            Line Type
          </div>
          <FormControl fullWidth size="small" style={{ fontSize: '12px', borderRadius: '4px' }}>
            <Select
              value={calStyle.splitLineType}
              variant="outlined"
              onChange={(e) => {
                updateCalendarStyleOptions(propKey, 'splitLineType', e.target.value);
              }}
              sx={{
                fontSize: '12px',
                width: '96%',
                margin: '0 auto 0.5rem 0.3rem',
                backgroundColor: 'white',
                height: '1.5rem',
                color: '#404040',
                textAlign: 'start',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#2bb9bb', // Set focused border color
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root.Mui-selected': {
                      backgroundColor: 'rgba(43, 185, 187, 0.1) !important', // Force background color
                    },
                    '& .MuiMenuItem-root.Mui-selected:hover': {
                      backgroundColor: 'rgba(43, 185, 187, 0.2) !important', // Change hover state for selected item
                    },
                  },
                },
              }}
            >
              <MenuItem value="solid" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                Solid
              </MenuItem>
              <MenuItem value="dashed" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                Dashed
              </MenuItem>
              <MenuItem value="dotted" sx={{ padding: '2px 10px', fontSize: '12px' }}>
                Dotted
              </MenuItem>
            </Select>
          </FormControl>
        </>
      ) : null}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div>
          <SketchPicker
            color={calStyle.splitLineColor}
            className="sketchPicker"
            width="16rem"
            // styles={{ padding: "0" }}
            onChangeComplete={(color) => {
              updateCalendarStyleOptions(propKey, 'splitLineColor', color.hex);
            }}
            onChange={(color) => updateCalendarStyleOptions(propKey, 'splitLineColor', color.hex)}
            disableAlpha
          />
        </div>
      </Popover>
    </div>
  );
};
const mapStateToProps = (state: ChartOptionsStateProps, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateCalendarStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateCalendarStyleOptions(propKey, option, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarChartStyles);
